var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Lib
import React, { lazy, Suspense } from "react";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import API from "../../forms/lib/API";
// Components
var Rating = lazy(function () { return import('./Rating'); });
import { RatingIcons } from "../interfaces/SearchPage";
var searchVenuesDebounced = AwesomeDebouncePromise(API.searchLocality, 500);
var GoogleAutocomplete = /** @class */ (function (_super) {
    __extends(GoogleAutocomplete, _super);
    function GoogleAutocomplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            inputValue: '',
            selectedOption: null,
            defaultOptions: [],
            loading: true,
            noResults: false,
            popoutOpen: false
        };
        _this.debouncedResults = null;
        _this.componentDidMount = function () {
            _this.setState({
                inputValue: _this.props.searchTerm || ''
            }, function () {
                _this.getLocalities(_this.state.inputValue)
                    .catch(function () { return _this.setState({ defaultOptions: [], noResults: true }); })
                    .finally(function () { return _this.setState({ loading: false }); });
            });
        };
        _this.onInputChange = function (event) {
            clearTimeout(_this.debouncedResults);
            _this.setState({ inputValue: event.currentTarget.value }, function () {
                _this.debouncedResults = setTimeout(function () {
                    _this.setState({ loading: true, noResults: false }, function () {
                        _this.getLocalities(_this.state.inputValue)
                            .catch(function () { return _this.setState({ defaultOptions: [], noResults: true }); })
                            .finally(function () { return _this.setState({ loading: false }); });
                    });
                }, 700);
            });
        };
        _this.getLoadingElement = function () {
            if (_this.state.inputValue !== null && _this.state.inputValue.length) {
                return (React.createElement("div", { className: "loading loading--small" },
                    React.createElement("svg", { className: "loading-animation loading__icon" },
                        React.createElement("use", { xlinkHref: "#icon--loading" }))));
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        };
        _this.getLocalities = function (inputValue) { return __awaiter(_this, void 0, void 0, function () {
            var results, newResults;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof inputValue === 'undefined' || !inputValue.length)
                            return [2 /*return*/];
                        return [4 /*yield*/, searchVenuesDebounced(inputValue)];
                    case 1:
                        results = _a.sent();
                        newResults = results.map(function (result) {
                            return __assign(__assign({}, result), { value: result.place_id, label: result.structured_formatting.main_text });
                        });
                        this.setState({ defaultOptions: newResults, loading: false });
                        return [2 /*return*/, newResults];
                }
            });
        }); };
        _this.selectLocality = function (placeID) {
            API.getPlaceDetails(placeID)
                .then(_this.props.onSelected)
                .catch(function (err) {
                // TODO: Add error
            });
        };
        _this.getItemIcon = function (types) {
            if (types.indexOf("establishment") !== -1 || types.indexOf("tourist_attraction") !== -1) {
                return "icon--marker";
            }
            if (types.indexOf("locality") !== -1) {
                return "icon--area";
            }
            return 'icon--location';
        };
        _this.renderResults = function () {
            return !_this.state.defaultOptions.length
                ? (_this.state.noResults ? (React.createElement("span", { className: "no-results" }, "No Results")) : null)
                : (React.createElement("ul", { className: "localities list--unstyled" }, _this.state.defaultOptions.map(function (option) { return _this.renderLocalityItem(option); })));
        };
        _this.renderLocalityItem = function (option) {
            var icon = _this.getItemIcon(option.types);
            var itemContent = (React.createElement(React.Fragment, null,
                React.createElement("svg", { className: "locality__icon" },
                    React.createElement("use", { xlinkHref: "#".concat(icon) })),
                React.createElement("div", { className: "locality__content" },
                    React.createElement("h3", { className: "locality__title" }, option.structured_formatting.main_text),
                    React.createElement("span", { className: "locality__secondary" }, option.structured_formatting.secondary_text),
                    option.exists && (React.createElement(Suspense, { fallback: React.createElement("span", { className: "rating-dummy" }) },
                        React.createElement(Rating, { number: option.rating, icon: RatingIcons.Heart, fillRest: true }))))));
            var item;
            if (option.is_establishment) {
                var href = option.exists
                    ? (option.permalink) ? option.permalink : "/submit-review/".concat(option.wordpress_post_id)
                    : "/submit-review/new/".concat(option.place_id);
                item = (React.createElement("a", { href: href, className: "locality" }, itemContent));
            }
            else {
                if (option.permalink !== "#") {
                    item = (React.createElement("a", { href: option.permalink, className: "locality" }, itemContent));
                }
                else {
                    item = (React.createElement("a", { href: "#", onClick: function () { return _this.selectLocality(option.place_id); }, className: "locality" }, itemContent));
                }
            }
            return (React.createElement("li", { key: "place-".concat(option.place_id) }, item));
        };
        return _this;
    }
    return GoogleAutocomplete;
}(React.Component));
export default GoogleAutocomplete;
